import { render } from "./ModalRenovacionesActivas.vue?vue&type=template&id=e8404ed0&scoped=true"
import script from "./ModalRenovacionesActivas.vue?vue&type=script&lang=js"
export * from "./ModalRenovacionesActivas.vue?vue&type=script&lang=js"

import "./ModalRenovacionesActivas.vue?vue&type=style&index=0&id=e8404ed0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8404ed0"]])

export default __exports__